(function(root,factory){
  if(typeof module==='object'&&module.exports)module.exports=factory();
  else root.OrienXEngravingRender=factory();
})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  const fonts={
    modern:{family:'OrienX Manrope',weight:400,spacing:.02,lineHeight:1.4,scale:1},
    classic:{family:'Georgia',weight:400,spacing:.02,lineHeight:1.4,scale:1},
    serif:{family:'Cormorant Garamond',weight:500,spacing:.015,lineHeight:1.45,scale:1.12},
    script:{family:'Allura',weight:400,spacing:0,lineHeight:1.55,scale:1.22}
  };
  function fontFor(id){return fonts[id]?{...fonts[id]}:null;}
  function configure(ctx,font,size){
    const f=fontFor(font);if(!f)throw TypeError('Unknown engraving font');
    ctx.font=`${f.weight} ${size}px "${f.family}"`;
    ctx.textAlign='center';ctx.textBaseline='middle';ctx.fontKerning='normal';
    if('letterSpacing'in ctx)ctx.letterSpacing=size*f.spacing+'px';
    return f;
  }
  function measure(ctx,texts,font,size){
    const S=1000,f=configure(ctx,font,size*S),step=size*S*f.lineHeight;
    let width=0,extent=0;
    texts.forEach((text,i)=>{
      const m=ctx.measureText(text),offset=(i-(texts.length-1)/2)*step;
      width=Math.max(width,m.width,2*Math.max(m.actualBoundingBoxLeft||0,m.actualBoundingBoxRight||0));
      extent=Math.max(extent,Math.abs(offset-(m.actualBoundingBoxAscent||size*S*.7)),Math.abs(offset+(m.actualBoundingBoxDescent||size*S*.3)));
    });
    return{w:width/S+.012,h:Math.max(extent*2/S,texts.length*size*f.lineHeight)+.012};
  }
  function drawText(ctx,design,S,color){
    const angle=design.angle??0;
    if(![0,90].includes(angle))throw TypeError('Unsupported engraving direction');
    const f=fontFor(design.font);if(!f)throw TypeError('Unknown engraving font');
    ctx.save();configure(ctx,design.font,design.layout.fontSize*S);
    ctx.fillStyle=color;ctx.translate(design.layout.x*S,design.layout.y*S);ctx.rotate(angle*Math.PI/180);
    const step=design.layout.fontSize*S*f.lineHeight;
    design.texts.forEach((text,i)=>ctx.fillText(text,0,(i-(design.texts.length-1)/2)*step));
    ctx.restore();
  }
  function canvas(S){const c=document.createElement('canvas');c.width=c.height=S;return c;}
  function material(image,g,S){
    const c=canvas(S),ctx=c.getContext('2d');
    ctx.fillStyle=g.ink;ctx.fillRect(0,0,S,S);
    ctx.globalCompositeOperation='multiply';ctx.globalAlpha=.16;ctx.drawImage(image,0,0,S,S);
    ctx.globalAlpha=1;ctx.globalCompositeOperation='source-over';return c;
  }
  function paintLaser(target,texture,design,g,mask=canvas(target.width)){
    const S=target.width,m=mask.getContext('2d'),ctx=target.getContext('2d');
    m.clearRect(0,0,S,S);m.save();m.filter=`blur(${.45*S/1600}px)`;
    drawText(m,design,S,'#fff');m.restore();
    ctx.clearRect(0,0,S,S);ctx.save();ctx.drawImage(texture,0,0,S,S);
    ctx.globalCompositeOperation='destination-in';ctx.globalAlpha=g.alpha;ctx.drawImage(mask,0,0,S,S);ctx.restore();
    return target;
  }
  return{fontFor,measure,drawText,material,paintLaser,canvas};
});
